module.exports = {"pathContext":{"name":"BillingGroupFeeType","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":"Flat dollar amount fee","isDeprecated":false,"name":"FLAT"},{"deprecationReason":null,"description":"Whichever is greater: flat amount or percentage","isDeprecated":false,"name":"GREATER_THAN"},{"deprecationReason":null,"description":"Percentage-based fee","isDeprecated":false,"name":"PERCENT"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-billing-group-fee-type.json
// module id = 1211
// module chunks = 217034719394758